module.exports = __webpack_public_path__ + "img/square-fill.ae95c998.svg";